export default "__VITE_ASSET__dWX7phUU__"